import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./PdfProximosAgendamentos.scss";
import { format } from "date-fns";

function PdfProximosAgendamentos({
  showPreviousPage,
  proximosAgendamentosData,
}) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Lista-Proximos-Agendamentos-${
      proximosAgendamentosData.cliente.nome
    }_${format(new Date(), "dd-MM-yyyy")}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  /* A coluna da unidade só existe se houver unidades para distinguir. Lê-se
     dos próprios dados e não da configuração da clínica: se nenhuma marcação
     trouxer unidade — registos anteriores à divisão, por exemplo —, a coluna
     sairia vazia de cima a baixo. */
  const mostrarUnidade = proximosAgendamentosData.lista.some(
    (l) => l.estabelecimento?.nome,
  );

  return (
    <>
      <div ref={componentRef} className="pdf-wrapper">
        <div className="pdf-listaAtendimentos-heading">
          <span className="semiDarkText">
            {proximosAgendamentosData.clinica.nome}
          </span>
          <span>Lista de agendamentos</span>
          <div>
            <span className="semiDarkText">
              {proximosAgendamentosData.cliente.nome}
            </span>
          </div>
          <div>
            <span>Nr de Agendamentos: </span>
            <span className="semiDarkText">
              {" " + proximosAgendamentosData.lista.length}
            </span>
          </div>
        </div>

        <div className="pdf-listaAtendimentos-table-container">
          <table className="listaAtendimentos-table">
            <tbody>
              <tr>
                <th>Data</th>
                <th>Horário</th>
                <th>Dentista</th>
                {/* ONDE É A CONSULTA.
                    Só aparece se alguma marcação trouxer unidade — nas
                    clínicas de unidade única ficaria uma coluna a repetir o
                    mesmo em todas as linhas, e o cabeçalho já diz o nome.
                    É o campo que faltava neste papel: o doente saía com a
                    hora e sem o sítio. */}
                {mostrarUnidade && <th>Onde</th>}
              </tr>
              {proximosAgendamentosData.lista.map((l, index) => (
                <tr key={index}>
                  <td>{format(new Date(l.data_completa), "dd/MM/yy")}</td>
                  <td>
                    {l.horaInicio} - {l.horaFim}
                  </td>
                  <td>{l.medico}</td>
                  {mostrarUnidade && (
                    <td>
                      {l.estabelecimento?.nome || ""}
                      {l.estabelecimento?.endereco ? (
                        <>
                          <br />
                          <span className="pdf-unidade-morada">
                            {l.estabelecimento.endereco}
                            {l.estabelecimento.cidade
                              ? `, ${l.estabelecimento.cidade}`
                              : ""}
                          </span>
                        </>
                      ) : null}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default PdfProximosAgendamentos;
